import { useTranslation } from "react-i18next";
import { BillRow } from "./BillRow";

// شبكة بطاقات مرنة — عمود على الجوال، عمودان على التابلت، ثلاثة على الحاسب.
export const BillsTable = ({ rows, branchesById, suppliersById, accountsByCode }) => {
  const { t } = useTranslation();
  if (!rows.length) {
    return (
      <div data-testid="bills-table"
           className="rounded-3xl border border-border/50 bg-background/70 py-14 text-center text-sm text-muted-foreground shadow-neu-sm">
        {t("acct.noBills")}
      </div>
    );
  }
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3" data-testid="bills-table">
      {rows.map((b) => (
        <BillRow key={b.id} bill={b}
                 branchName={branchesById[b.branch_id]}
                 supplierName={suppliersById[b.supplier_id]}
                 accountName={accountsByCode[b.expense_account]} />
      ))}
    </div>
  );
};
